<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">Copyright © 2007 by Peter Ho Davies</p>
<div class="timebreak "> </div>
<p class="center "><span class="smallcaps">ALL RIGHTS RESERVED</span></p>
<div class="timebreak "> </div>
<p class="center ">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<div class="timebreak "> </div>
<p class="center "><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<div class="timebreak "> </div>
<p class="center "><em>The Library of Congress has cataloged the print edition as follows:</em><br/>
Davies, Peter Ho, date.<br/>
The Welsh girl : a novel / Peter Ho Davies.<br/>
p. cm.<br/>
<span class="smallcaps">ISBN</span>-13: 978-0-618-00700-4<br/>
<span class="smallcaps">ISBN</span>-10: 0-618-00700-8<br/>
1. Prisoners of war—Germany—Fiction. 2. Prisoners of war—Wales—Fiction. 3. Young women—Wales—Fiction. 4. World War, 1939–1945—Fiction. 5. Wales—Fiction. I. Title.</p>
<p class="center "><span class="smallcaps">PR</span>6054.<span class="smallcaps">A</span>89145<span class="smallcaps">W</span>45 2007<br/>
823'.914—dc22 2006015358</p>
<div class="timebreak "> </div>
<p class="center ">e<span class="smallcaps">ISBN</span> 978-0-547-52490-0<br/>
v3.0716</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?26d0b613